/* eslint-disable indent */
import { Table } from "antd";

import { colors } from "../../utils/variables";
import { __ } from "../../locales/translation";
import { formatPriceToAR } from "../../utils/utils";

const columns = [
    {
        title: __("Clase"),
        key: "clase",
        render: (_, record) => (
            <span className="medium-text" style={{ color: colors.blackish_70, fontWeight: 600 }}>
                {record.clase}
            </span>
        ),
    },
    {
        title: __("Patrimonio Total"),
        key: "patrimonioTotal",
        render: (_, record) => (
            <span className="medium-text" style={{ color: colors.blackish_70 }}>
                {record.patrimonioTotal}
            </span>
        ),
        responsive: ["md"],
    },
    {
        title: __("VCP"),
        key: "valorCP",
        render: (_, record) => (
            <span className="medium-text" style={{ color: colors.blackish_70 }}>
                {record.valorCP}
            </span>
        ),
        responsive: ["md"],
    },
    {
        title: __("Var Diaria") + " %",
        key: "variations.diaria",
        render: (_, record) => (
            <span className="medium-text" style={{ color: colors.blackish_70 }}>
                {record.variations.diaria}
            </span>
        ),
    },
    {
        title: __("7d"),
        key: "variations.semana",
        render: (_, record) => (
            <span className="medium-text" style={{ color: colors.blackish_70 }}>
                {record.variations.semana}
            </span>
        ),
        responsive: ["md"],
    },
    {
        title: __("30d"),
        key: "variations.meses1",
        render: (_, record) => (
            <span className="medium-text" style={{ color: colors.blackish_70 }}>
                {record.variations.meses1}
            </span>
        ),
        responsive: ["md"],
    },
    {
        title: __("6m"),
        key: "variations.meses6",
        render: (_, record) => (
            <span className="medium-text" style={{ color: colors.blackish_70 }}>
                {record.variations.meses6}
            </span>
        ),
        responsive: ["lg"],
    },
    {
        title: __("1y"),
        key: "variations.meses12",
        render: (_, record) => (
            <span className="medium-text" style={{ color: colors.blackish_70 }}>
                {record.variations.meses12}
            </span>
        ),
        responsive: ["lg"],
    },
    {
        title: __("YTD"),
        key: "variations.ytd",
        render: (_, record) => (
            <span className="medium-text" style={{ color: colors.blackish_70 }}>
                {record.variations.ytd}
            </span>
        ),
    },
];

export default function VariationTable({ data }) {
    const { clase, patrimonioTotal, variacion, precioUltimo, fecha, benchmark } = data;

    const benchmarkObj = benchmark
        ? {
              key: "2",
              clase: benchmark.clase || "-",
              patrimonioTotal: benchmark.patrimonioTotal || "-",
              valorCP: formatPriceToAR(benchmark.vcp) || "-",
              variations: {
                  diaria: benchmark.variacion.diaria || "-",
                  semana: benchmark.variacion.semana || "-",
                  meses1: benchmark.variacion.meses1 || "-",
                  meses6: benchmark.variacion.meses6 || "-",
                  meses12: benchmark.variacion.meses12 || "-",
                  ytd: benchmark.variacion.ytd || "-",
              },
          }
        : null;

    // Aquí verificamos si benchmarkObj es distinto de null antes de agregarlo a dataSource.
    const dataSource = [
        {
            key: "1",
            clase,
            patrimonioTotal,
            valorCP: precioUltimo,
            variations: {
                diaria: variacion.diaria,
                semana: variacion.semana,
                meses1: variacion.meses1,
                meses6: variacion.meses6,
                meses12: variacion.meses12,
                ytd: variacion.ytd,
            },
        },
        ...(benchmarkObj ? [benchmarkObj] : []),
    ];

    return (
        <div className="cot-var-table-container">
            <p className="small-text label">
                {__("Valores porcentuales sobre al")} {fecha}
            </p>
            <Table dataSource={dataSource} columns={columns} pagination={false} />
        </div>
    );
}
